<template>
  <div style="padding-top: 20px">
    <div style="display: flex;align-items: center;gap: 10px;margin-bottom: 20px;">
      <div style="font-weight: 800;font-size: 18px">
        附件信息
      </div>
      <el-upload
        v-if="isUpload"
        action=""
        :http-request="uploadAction"
        :show-file-list="false"
      >
        <el-button type="primary">
          上传附件
        </el-button>
      </el-upload>
    </div>
    <el-progress v-if="onUpload" :width="200" :percentage="filePercentage" />
    <el-table v-loading="fileTableLoading" :data="fileTableList">
      <el-table-column align="left" prop="fileName" label="文件名称">
        <template v-slot="{row}">
          <el-button type="text" @click="lookThisFile(row)">
            {{ row.fileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="createBy" label="上传人" />
      <el-table-column align="left" prop="createTime" label="上传时间" />
      <el-table-column align="left" label="操作" width="100">
        <template v-slot="{row,$index}">
          <el-popconfirm
            v-if="isUpload"
            confirm-button-text="确定"
            cancel-button-text="取消"
            icon=""
            title="确认删除该文件吗？"
            @confirm="deleteFile($index, row)"
          >
            <el-button slot="reference" type="text" style="color: #FF0000">
              删除
            </el-button>
          </el-popconfirm>

          <el-button type="text" @click="fileClick(row)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script type="es6">
import { attachmentGetToken, getUrlByFileID } from '@/API';
import { Message } from 'element-ui';
import AxiosApi from '@/API/fileAxios';
import { deepCopy, downloadUrlFile, formatDate } from '@/libs/util';
import { mapState } from 'vuex';

export default {
  props: {
    // 开启上传
    isUpload: {
      type: Boolean,
      default: true
    },
    fileList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      // 上传地址
      uploadUrl: '',
      onUpload: false,
      token: '',
      downloadUrl: '',
      // 貌似这个是下载压缩包的url，可以留作拓展
      downloadZipUrl: '',
      filePercentage: 0,
      fileTableList: [],
      // 附件表格loading
      fileTableLoading: false
    };
  },
  watch: {
    fileList: {
      handler (nextValue) {
        this.fileTableList = deepCopy(nextValue);
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    /**
     * 获取token
     */
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (Number(json.status) === 200) {
          this.uploadUrl = json.data.uploadUrl;
          this.token = json.data.token;
          this.downloadUrl = json.data.downloadUrl;
          this.downloadZipUrl = json.data.downloadZipUrl;
        }
      }).catch(() => {
        Message.error('获取文件上传参数错误,请联系管理员！');
      });
    },
    uploadAction (upload) {
      let lastLen = upload.file.name.lastIndexOf('.');
      let len = upload.file.name.length;
      let pathf = upload.file.name.substring(lastLen, len);
      // if (checkSpecialCharacters(upload.file.name)) {
      //   this.$message.error('文件名中不能包含特殊字符！');
      //   return;
      // }
      if (!['.pdf', '.doc', '.docx', '.jpg', '.png', '.gif', '.zip', '.rar', '.xlsx', '.xls'].includes(pathf)) {
        this.$message.error('文件只允许pdf word 图片 压缩包上传！');
        return;
      }
      const isLt0M = upload.file.size > 31457280;
      if (isLt0M) {
        this.$message.error('上传文件大小不能大于30M!');
        return false;
      }

      const form = new FormData();
      form.append('files', upload.file);
      this.onUpload = true;
      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          this.filePercentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          const fileInfo = {
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID,
            createTime: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
            createBy: this.user.userName
          };
          this.fileTableList.push(fileInfo);
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
        this.onUpload = false;
        this.filePercentage = 0;
      }).catch(() => {
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        this.onUpload = false;
        this.filePercentage = 0;
      });
    },
    fileClick (row) {
      console.log(row);
      const fileServeDownUrl = this.downloadUrl + `/${row.fileToken}?Token=${this.token}`;
      downloadUrlFile(fileServeDownUrl, row.fileName);
    },
    deleteFile (tag) {
      this.fileTableList.splice(tag, 1);
    },
    lookThisFile (row) {
      getUrlByFileID(row.fileToken).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          window.open(json.data);
        }
      });
    },
    getFileList () {
      return deepCopy(this.fileTableList);
    }
  },
  destroyed () {
    this.uploadUrl = '';
    this.onUpload = false;
    this.token = '';
    this.downloadUrl = '';
    // 貌似这个是下载压缩包的url，可以留作拓展
    this.downloadZipUrl = '';
    this.filePercentage = 0;
    this.fileTableList = [];
    // 附件表格loading
    this.fileTableLoading = false;
  },
  mounted () {
    this.initToken();
  }
};
</script>
